export default __webpack_public_path__ + "static/media/header.fbdd7bed.jpg";